import axios from '~/utils/axios';
import { HeadTransaction } from '~/types/HeadTransaction';

interface ReferenceEntry {
  id: string;
  value: string;
}

export interface ServiceChargeSubtype {
  id: string;
  name: string;
}

interface GetSubtypesResponse {
  subtypes: ServiceChargeSubtype[];
}

export const getSubtypes = (accountId: string) => {
  const url = `/serviceCharge/subtypes`;
  return axios.post<GetSubtypesResponse>(url, { accountId });
};

export interface CreateConsentRequest {
  operationSubtype: string;
  senderAccountId: string;
  note?: string;
  referenceId?: ReferenceEntry[];
  localUTCOffset?: string;
}

export const createConsent = (request: CreateConsentRequest) => {
  const url = `/serviceCharge/consent`;
  return axios.post<HeadTransaction>(url, request);
};

export const updateConsent = (id: string, request: CreateConsentRequest) => {
  const url = `/serviceCharge/consent/${id}`;
  return axios.put<HeadTransaction>(url, request);
};

interface CreateTransactionProps {
  consentId: string;
}

export const createTransaction = ({ consentId }: CreateTransactionProps) => {
  const url = `/serviceCharge`;
  return axios.post<HeadTransaction>(url, { consentId });
};
